import { Platform } from 'react-native';

/**
 *
 * @returns true if Platform is 'windows'
 */
export const isWindowsDevice = () => {
  return Platform.OS === 'windows';
};
